import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, from, switchMap } from 'rxjs';
import { inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const msalService = inject(MsalService);

  // Only add auth header for API calls
  if (req.url.startsWith(environment.serverUrl)) {
    const accounts = msalService.instance.getAllAccounts();

    if (accounts.length > 0) {
      const account = msalService.instance.getActiveAccount() || accounts[0];

      // Manually acquire token and add to request
      const silentRequest = {
        scopes: environment.apiScope,
        account: account
      };

      return from(msalService.instance.acquireTokenSilent(silentRequest)).pipe(
        catchError(() => {
          // If MSAL token acquisition fails, return a mock result with an empty token
          // so the outer switchMap can gracefully fall back to a tokenless request.
          return from([{ accessToken: null }]);
        }),
        switchMap(result => {
          if (!result.accessToken) {
            return next(req); // Sends original request without bearer token if MSAL failed
          }

          const authReq = req.clone({
            setHeaders: {
              authorization: `Bearer ${result.accessToken}`
            }
          });

          return next(authReq); // Sends request with token. If this fails, it won't be caught here.
        })
      );
    }
  }

  return next(req);
};
